import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useSelector } from 'react-redux';
import DragHandle from '@components/common/DnD/DragHandle';
import { tid } from '@utils/test';
import { TABLE_HEIGHT_MAPPING } from '@components/dimension-panel-hz/header/Resize';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import AppDimensionTable from './appDimensionTable';
import { dimensionTraceId } from './utils/constant';
import { DimensionNameWrapper, DimensionTableWrapper } from './styled';

function DimensionTableWidget({ dimension }) {
  const dimensions = useSelector(allDimensionsListSelector);
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: dimension,
  });
  let label = dimension;
  if (dimension === dimensionTraceId) {
    label = 'Trace Id';
  } else {
    const target = dimensions.find((it) => it.groupBy === dimension);
    if (target) {
      label = target.name;
    }
  }

  const dndStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    gridRow: `span ${gridRow}`,
  };

  return (
    <DimensionTableWrapper
      id={dimension}
      ref={setNodeRef}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DragHandle {...attributes} {...listeners} />
      <DimensionNameWrapper>{label}</DimensionNameWrapper>
      <AppDimensionTable dimension={dimension} updateGrid={updateGrid} />
    </DimensionTableWrapper>
  );
}

export default DimensionTableWidget;
